// removed by extract-text-webpack-plugin
module.exports = {"exception":"antd-pro-exception","imgBlock":"antd-pro-imgBlock","imgEle":"antd-pro-imgEle","content":"antd-pro-content","desc":"antd-pro-desc","actions":"antd-pro-actions"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Exception/index.less
// module id = 406
// module chunks = 0 1